module.exports = __webpack_public_path__ + "img/banner-bg.5c27210a.jpg";